import { Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "@/shared/config/i18n";
import AppRouter from "@/app/providers/router/ui/AppRouter";

export const App = () => {
    const location = useLocation();

    useEffect(() => {
        const langFromUrl = location.pathname.split("/")[1];
        const supportedLangs = ["ru", "en", "cn", "ar", "es", "de"];
        const lang = supportedLangs.includes(langFromUrl) ? langFromUrl : "ru";
        i18n.changeLanguage(lang);
    }, [location.pathname]);

    return (
        <Suspense fallback="">
            <AppRouter />
        </Suspense>
    );
};